<template>
  <b-form v-if="!loading && invoice_settings" @submit="onSubmit">
    <legend v-translate>Invoice sending</legend><hr>
    <b-form-group id="input-group-4" label-cols-sm="3" label-align-sm="right" content-cols-md="5" label-class="gk-label-margin" :label="$gettext('Default VAT')" label-for="input-4">
      <b-input-group append="%" class="width50">
        <b-form-input id="input-4" type="number" v-model="invoice_settings.default_tax_rate" placeholder="0.0" @change="onFormChange" :disabled="defaultVatDisabled"></b-form-input>
      </b-input-group>
    </b-form-group>
    <b-form-group id="input-group-5" label-cols-sm="3" label-align-sm="right" content-cols-md="5" label-class="gk-label-margin">
      <b-form-checkbox id="input-5" class="checkbox-bg-color" v-model="invoice_settings.default_tax_rate_exempt" :disabled="vatExemptDisabled" @change="onFormChange" switch><span v-translate>VAT exempt</span></b-form-checkbox>
    </b-form-group>
    <b-form-group id="input-group-6" label-cols-sm="3" label-align-sm="right" content-cols-md="5" label-class="gk-label-margin">
      <b-form-checkbox id="input-6" class="checkbox-bg-color" v-model="invoice_settings.default_tax_rate_reversed" :disabled="vatReversedChargeDisabled" @change="onFormChange" switch><span v-translate>VAT reversed charge</span></b-form-checkbox>
    </b-form-group>
    <b-form-group id="input-group-7" label-cols-sm="3" label-align-sm="right" content-cols-md="5" label-class="gk-label-margin" :label="$gettext('Invoice Inc./Ex. VAT')" label-for="input-7">
      <template v-slot:description>
        <p id="hint_id_default_invoice_inc_vat" class="help-block">
          {{ $gettext('Show the invoice lines including or excluding VAT.') }}<br>
          {{ $gettext('Ex. VAT is normal when invoicing businesses.') }}<br>
          {{ $gettext('Inc. VAT can be used when selling to consumers.') }}
        </p>
      </template>
      <b-form-select id="input-7" v-model="invoice_settings.companysettings.default_invoice_inc_vat" :options="incExVat" @change="onFormChange" required></b-form-select>
    </b-form-group>
    <b-form-group id="input-group-8" label-cols-sm="3" label-align-sm="right" content-cols-md="5" label-class="gk-label-margin" :label="$gettext('Default payment term*')" label-for="input-8">
      <b-input-group :append="$gettext('days')" class="width50">
        <b-form-input id="input-8" type="number" v-model="invoice_settings.default_payment_term" placeholder="30" @change="onFormChange"></b-form-input>
      </b-input-group>
    </b-form-group>
    <b-form-group id="input-group-9" label-cols-sm="3" label-align-sm="right" content-cols-md="5" label-class="gk-label-margin" :label="$gettext('Default invoice message')" label-for="input-9" :description="$gettext('This is the default message at the bottom of each invoice.')">
      <b-form-textarea id="input-9" v-model="invoice_settings.default_invoice_message" :placeholder="$gettext('Please complete payment for this invoice within 30 days from the date on this invoice.')" rows="3" @change="onFormChange"></b-form-textarea>
    </b-form-group>

    <b-form-group id="input-group-1" label-cols-sm="3" label-align-sm="right" content-cols-md="5" label-class="gk-label-margin" :label="$gettext('Email')" label-for="input-1" :description="$gettext('Invoices will be sent from this e-mail address.')">
      <b-form-input id="input-1" v-model="invoice_settings.email" :placeholder="$gettext('john.doe@email.com')" @change="onFormChange"></b-form-input>
    </b-form-group>
    <b-form-group id="input-group-2" label-cols-sm="3" label-align-sm="right" content-cols-md="5" label-class="gk-label-margin">
      <b-form-checkbox id="input-2" class="checkbox-bg-color" v-model="invoice_settings.companysettings.include_sender_in_cc" @change="onFormChange" switch><span v-translate>Send me a copy of each sent invoice</span></b-form-checkbox>
    </b-form-group>
    <b-form-group id="input-group-3" label-cols-sm="3" label-align-sm="right" content-cols-md="5" label-class="gk-label-margin">
      <b-form-checkbox id="input-3" class="checkbox-bg-color" v-model="invoice_settings.companysettings.attach_ubl_to_invoice" @change="onFormChange" switch><span v-translate>Attach a UBL invoice to every sent invoice</span></b-form-checkbox>
    </b-form-group>
    <b-form-group id="input-group-9" label-cols-sm="3" label-align-sm="right" content-cols-md="5" label-class="gk-label-margin" :label="$gettext('Default invoice email message')" label-for="input-9" :description="$gettext('This is the default email message when sending an invoice.')">
      <b-form-textarea id="input-9" v-model="invoice_settings.companysettings.default_invoice_email_message" :placeholder="$gettext('Dear john, please find my invoice attached to this email. Have a nice day!')" rows="3" @change="onFormChange"></b-form-textarea>
    </b-form-group>

    <legend v-translate>Importing hours</legend><hr>
    <b-form-group id="input-group-28" label-cols-sm="3" label-align-sm="right" content-cols-md="5" label-class="gk-label-margin" :label="$gettext('Default hourly rate (Ex. VAT)')" label-for="input-28" :description="$gettext('The default rate we use when creating an invoice from your hours.')">
      <b-input-group pre="€" class="width50">
        <b-form-input id="input-28" type="number" v-model="invoice_settings.hourly_rate" step="0.01" placeholder="30" @change="onFormChange"></b-form-input>
      </b-input-group>
    </b-form-group>
    <b-form-group id="input-group-29" label-cols-sm="3" label-align-sm="right" content-cols-md="5" label-class="gk-label-margin" :label="$gettext('Select Rounding Precision')" label-for="input-29" :description="$gettext('When copying hours to a new invoice we convert from time (1 hour 30 minutes) to a quantity (1,5 hours). This setting allows you to choose your preferred precision.')">
      <b-form-select id="input-29" v-model="invoice_settings.hours_rounding_precision" :options="hourRoundingPrecisionList" @change="onFormChange" required></b-form-select>
    </b-form-group>

    <legend v-translate>Importing trips</legend><hr>
    <b-form-group id="input-group-30" label-cols-sm="3" label-align-sm="right" content-cols-md="5" label-class="gk-label-margin" :label="$gettext('Default km compensation (Ex. VAT)')" label-for="input-30">
      <b-input-group pre="€" class="width50">
        <b-form-input id="input-30" type="number" v-model="invoice_settings.default_km_rate" step="0.01" placeholder="30" @change="onFormChange"></b-form-input>
      </b-input-group>
    </b-form-group>

    <b-form-group v-if="!onModal" id="input-group-31" label-cols-sm="3" label-align-sm="right" content-cols-md="5" label-class="gk-label-margin" label="" label-for="input-31">
      <GekkoButton 
        :text="$gettext('Save Settings')" 
        icon="fa-solid fa-floppy-disk"
        type="submit"
      />
    </b-form-group>
  </b-form>
</template>

<script>
import { mapGetters, mapActions } from "vuex";

import CompanyService from "@/store/services/company.service.js"
import CompanySettingService from "@/store/services/companysetting.service.js"

import VueDropzone from "@/components/VueDropzone"
import GekkoButton from "@/components/GekkoButton"

export default {
  name: "InvoiceSettings",
  components: {
    VueDropzone,
    GekkoButton
  },
  props: {
    onModal: {
      type: Boolean,
      default: false 
    },
  },
  data () {
    return {
      formChanged: false,
      invoice_settings: null,
      incExVat:[
        { value: true, text:this.$gettext('Inc. VAT') },
        { value: false, text:this.$gettext('Ex. VAT') }
      ],
      hourRoundingPrecisionList: [
        { value: 0, text:this.$gettext('Zero decimals (e.g. 1 hour)') },
        { value: 1, text:this.$gettext('One decimal (e.g. 1,2 hours)') },
        { value: 2, text:this.$gettext('Two decimals (e.g. 1,25 hours)') }
      ],
      imageSrc: '',
      loading: true
    }
  },
  computed: {
    ...mapGetters({
      currentCompany: "main/getCurrentCompany"
    }),
    vatExemptDisabled () {
      return this.invoice_settings.default_tax_rate_reversed;
    },
    vatReversedChargeDisabled () {
      return this.invoice_settings.default_tax_rate_exempt;
    },
    defaultVatDisabled () {
      return this.invoice_settings.default_tax_rate_exempt || this.invoice_settings.default_tax_rate_reversed;
    }
  },
  created () {
    this.setupData()
  },
  methods: {
    ...mapActions({
      refreshCompanyData: "main/refreshCompanyData"
    }),
    setupData () {
      this.invoice_settings = Object.assign({}, this.currentCompany)
      if (this.invoice_settings.logo) {
        this.imageSrc = this.invoice_settings.logo
      }
      this.invoice_settings.logo = null
      this.loading = false
    },
    parentSubmit () {
      this.saveSettings()
    },
    onSubmit(evt) {
      evt.preventDefault()
      this.saveSettings()
    },
    saveSettings () {
      // create or edit
      if (this.invoice_settings.logo === null) {
        delete(this.invoice_settings.logo);
      }
      if (this.invoice_settings.id) {
        CompanyService.update(this.invoice_settings).then(() => {
          this.$emit('updated')
          this.formChanged = false;
        });

        let companySettings = this.invoice_settings.companysettings
        delete companySettings.dashboard_config
        CompanySettingService.update(companySettings)

        this.refreshCompanyData() // refresh store company data
      }
    },
    onFormChange(){
      this.formChanged = true;
    }
  }
};
</script>
<style lang="scss">
// TODO refactor this
.checkbox-bg-color .custom-control-input:checked ~ .custom-control-label::before{
  border-color: #0575ff;
  background-color: #0575ff;
}
.width50 {
  max-width: 41.6666666667% !important;
  width: 41.6666666667%  !important;
}
.float-alert-top{
  position: fixed !important;
  top: 50px;
  right: 15%;
  z-index: 1000;
}
</style>
